import React, { useMemo, useState } from 'react';
import SearchPicture from '../SearchPicture/SearchPicture';
import VideoCardDetails from '../VideoCard/VideoCardDetails';
import { defaultFilters } from '../Filters/Filters';
import { faVideo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useDebounce from '../../hooks/useDebounce';
import useInfinitePixabay from '../../hooks/useInfinitePixabay';
import { SkeletonGrid } from '../Skeleton/SkeletonCard';
import LoadMoreSentinel from '../InfiniteScroll/LoadMoreSentinel';

const Videos = () => {
    const [query, setQuery] = useState('');
    const [filters, setFilters] = useState(defaultFilters);

    const term = useDebounce(query, 500);

    const params = useMemo(() => ({
        q: term,
        order: filters.order,
        safesearch: String(filters.safesearch),
        min_width: filters.minWidth || '',
    }), [term, filters]);

    const {
        items: videos,
        total,
        loading,
        loadingMore,
        error,
        hasMore,
        loadMore,
    } = useInfinitePixabay('https://pixabay.com/api/videos/', params);

    return (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16">
            <SearchPicture
                value={query}
                onChange={setQuery}
                filters={filters}
                setFilters={setFilters}
                showColor={false}
                showOrientation={false}
                words={['videos', 'clips', 'footage']}
            />

            {!loading && !error && videos.length > 0 &&
                <h2 className="text-xl sm:text-2xl font-extrabold text-gray-900 dark:text-white mb-6">
                    {total.toLocaleString()} Free videos
                    {term && <span className="capitalize"> of {term}</span>}
                </h2>
            }

            {loading && <SkeletonGrid count={6} />}

            {!loading && error &&
                <div className="flex flex-col items-center justify-center text-center mt-16 text-rose-400">
                    <FontAwesomeIcon icon={faVideo} className="text-6xl mb-4" />
                    <h2 className="text-2xl font-bold">Something went wrong</h2>
                    <p className="mt-1">{error}</p>
                </div>
            }

            {!loading && !error && videos.length === 0 &&
                <div className="flex flex-col items-center justify-center text-center mt-16 text-gray-400 dark:text-gray-500">
                    <FontAwesomeIcon icon={faVideo} className="text-6xl mb-4" />
                    <h2 className="text-2xl font-bold">No videos found</h2>
                    <p className="mt-1">Try searching for something else.</p>
                </div>
            }

            {!loading && videos.length > 0 &&
                <>
                    <div className="grid sm:grid-cols-2 md:grid-cols-3 grid-cols-1 gap-6 animate-fade-in">
                        {
                            videos.map(video => <VideoCardDetails key={video.id} video={video} />)
                        }
                    </div>
                    <LoadMoreSentinel onLoadMore={loadMore} hasMore={hasMore} loadingMore={loadingMore} />
                </>
            }
        </div>
    );
};

export default Videos;
